var React = require('react');

function Zap (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.3057 1.81355C16.6847 1.35883 17.3184 1.20871 17.8614 1.44441C18.4042 1.68009 18.7266 2.24494 18.6534 2.8321L17.5079 12.0001H27.9971C28.5145 12.0001 28.9847 12.3001 29.2042 12.7686C29.4235 13.2371 29.3527 13.7902 29.0216 14.1876L15.6885 30.1876C15.3096 30.6423 14.6758 30.7924 14.1329 30.5567C13.59 30.321 13.2675 29.7554 13.3409 29.168L14.4864 20.0001H3.99714C3.47981 20.0001 3.00957 19.701 2.79011 19.2325C2.57069 18.764 2.64159 18.211 2.97273 17.8135L16.3057 1.81355ZM6.84382 17.3341H15.9971C16.3796 17.3341 16.744 17.4976 16.9971 17.7843C17.2502 18.0709 17.3677 18.4527 17.3204 18.8321L16.5499 24.9864L25.1505 14.6671H15.9971C15.6147 14.6671 15.2502 14.5026 14.9971 14.2159C14.7443 13.9292 14.6265 13.5474 14.6739 13.168L15.4434 7.01374L6.84382 17.3341Z"}));
}

Zap.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Zap;

Zap.default = Zap;
